<template>
  <div class="w-[100%]">
    <el-table size="mini" class="dg-table" v-bind="$attrs" :data="tableData" :height="height" :max-height="maxHeight"
      :row-class-name="rowClassName" @sort-change="handleSortChange" @selection-change="handleSelectionChange"
      :header-cell-class-name="handleHeaderCellClass">
      <el-table-column width="50" type="selection" :align="align" v-if="showSelection"></el-table-column>
      <el-table-column v-if="showIndex" width="50" type="index" label="序号" align="center"
        label-class-name="customindex"></el-table-column>
      <template v-for="item in currentColumns">
        <dg-table-column :key="item.prop" :column="item" @handleSearchHeader="handleSearchHeader">
          <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="slotData">
            <slot :name="slotName" v-bind="slotData"></slot>
          </template>
        </dg-table-column>
      </template>
      <!-- 一个按钮建议宽度89,两个按钮建议宽度155,三个按钮建议宽度221,四个按钮建议宽度287 -->
      <el-table-column v-if="operationColumn" :key="operationColumn.prop" :fixed="operationColumn.fixed"
        :label="operationColumn.label || '操作'" :width="operationColumn.width || 62" class-name="action-class">
        <template slot="default" slot-scope="scope">
          <template v-for="(curr, index) in operationColumn.options">
            <el-button size="mini" :key="index" :type="curr.type" :icon="curr.icon" :plain="curr.plain"
              @click="curr.method(scope.row)" v-if="typeof curr.show == 'function' ? curr.show(scope.row) : curr.show">
              {{ curr.label }}
            </el-button>
          </template>
          <slot name="action" v-bind="scope"></slot>
        </template>
      </el-table-column>
      <template slot="empty">
        <slot v-if="$slots.empty" name="empty"></slot>
        <div v-else class="empty-box">
          <i class="el-icon-warning empty-icon"></i>
          <div class="empty-text">暂无数据</div>
        </div>
      </template>
    </el-table>
    <!-- 分页器 -->
    <div class="pagination-box" v-if="showPagination">
      <el-pagination :small="true" :pager-count="5" :background="true" :total="currentPagination.total"
        :page-size="currentPagination.pageSize" :page-sizes="currentPagination.pageSizes"
        :current-page="currentPagination.currentPage" @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :layout="currentPagination.layout || 'total, prev, pager, next,sizes, jumper'">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DgTableColumn from "./dg-table-column.vue";
export default {
  name: 'DgTable',
  components: {
    DgTableColumn,
  },
  props: {
    // 接口
    api: {
      type: Object,
      default: () => { }
    },
    // 列表数据
    tableData: {
      type: Array,
      default: () => [],
      required: true
    },
    align: {
      type: String,
      default: 'left'
    },
    height: [String, Number],
    maxHeight: [String, Number],
    // 列表项配置
    columns: {
      type: Array,
      default: () => [],
      required: true
    },
    // 是否显示列表复选框
    showSelection: {
      type: Boolean,
      default: true
    },
    // 是否显示列表序号
    showIndex: {
      type: Boolean,
      default: true
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 分页器
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 10,
          pageSizes: [10, 20, 30, 40, 50],
          total: 0,
          layout: 'total, prev, pager, next,sizes, jumper'
        };
      }
    },
    rowClassName: {
      type: Function,
      default: () => { }
    },
  },
  data() {
    return {
      currentPagination: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 40, 50],
        total: 0,
        layout: 'total, prev, pager, next,sizes, jumper'
      },
      currentColumns: [],
      orderArray: [],
      operationColumn: {},
    }
  },
  watch: {
    pagination: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.currentPagination = { ...newVal, currentPage: newVal.pageNo };
        }
      }
    },
    columns: {
      deep: true,
      immediate: true,
      handler() {
        this.filterColumns(this.api);
      }
    }
  },
  computed: {
    // currentColumns() {
    //   return this.columns.filter(item => item.prop !== 'action');
    // },
    // operationColumn() {
    //   let operationColumn = this.columns.find(item => item.prop === 'action');
    //   return operationColumn;
    // }
  },
  methods: {
    //添加排序方法（可把多个字段共同加入排序）
    handleHeaderCellClass({ column }) {
      this.orderArray.forEach((element) => {
        if (column.property === element.prop) {
          column.order = element.order;
        }
      });
    },
    async filterColumns(api) {
      let operationColumn = this.columns.find(item => item.prop === 'action');
      this.operationColumn = operationColumn;
      const columns = this.columns.filter(item => item.prop !== 'action');
      if (api && api.status && api.status.length) {
        let _columns = []
        for (let i = 0; i < columns.length; i++) {
          const item = columns[i];
          const status = api.status.find((statu) => statu.key === item.currentKey);
          if (status?.url && status?.url != "/customer/status") {
            const res = await ajax.post({
              url: status?.url || '',
              data: status?.params || {},
              self: this,
            });
            console.log('res', res);
            _columns.push({
              ...item,
              url: status?.url || '',
              options: status?.success ? status?.success(res.data || []) : res.data || [],
              isMultiple: status?.isMultiple || false,
              currentKey: status?.key || '',
              params: status?.params || {},
              checkStatus: status?.checkStatus || [],
              noAjax: true,
            });
          } else {
            _columns.push({
              ...item,
              url: status?.url || '',
              options: status?.options || [],
              isMultiple: status?.isMultiple || false,
              currentKey: status?.key || '',
              params: status?.params || {},
              checkStatus: status?.checkStatus || [],
            });
          }
        }
        this.currentColumns = _columns;
        return;
      }
      this.currentColumns = columns;
    },
    handleSearchHeader(obj) {
      this.$emit('handleSearchStatus', obj)
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      this.currentPagination.pageSize = val;
      this.$emit('handleSizeChange', val);
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.currentPagination.currentPage = val;
      this.$emit('handleCurrentChange', val);
    },
    // 复选框
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    // 列表排序事件
    handleSortChange({ column, prop, order }) {
      if (order) {
        //参与排序
        let flagIsHave = false;
        this.orderArray.forEach((element) => {
          if (element.prop === prop) {
            element.order = order;
            flagIsHave = true;
          }
        });
        if (!flagIsHave) {
          this.orderArray.push({
            prop: prop,
            order: order,
          });
        }
      } else {
        //不参与排序
        this.orderArray = this.orderArray.filter((element) => {
          return element.prop !== prop
        });
      }
      //调后端接口进行排序操作, this.orderArray就是最终排序后的集合
      this.$emit('handleSortChange', { column, prop, order });
    },
  },
  created() {
    
  },
};
</script>

<style lang="less" scoped>
// @import "~@/assets/css/var.less";

.dg-table {
  margin-top: 16px;
}

.dg-table /deep/ .customindex {
  padding: 0px 10px !important;
}

.dg-table /deep/ .empty-box {
  width: 400px;
  height: 40px;
  margin: 40px auto;
  background: #FAFAFC;
  border: 1px solid #D2D6EA;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .empty-icon {
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 17px;
    transform: translateY(-50%);
    color: @theme;
  }

  .empty-text {
    font-size: 12px;
    color: #303133;
    text-align: center;
  }
}

.dg-table /deep/ th.el-table__cell>.cell {
  font-weight: 400 !important;
  color: #526075 !important;
}

.dg-table /deep/ .el-table__row .el-table__cell .cell {
  padding: 5.5px 12px !important;
  font-size: 14px !important;
  color: #303133 !important;
  line-height: unset !important;
}

// 分页器
.pagination-box {
  margin-top: 16px;
  text-align: right;

  .el-pagination .el-pagination__jump {
    margin-left: 0;
    height: 24px;
    line-height: 24px;
    position: relative;
    top: -1px;

    .el-pagination--small .el-pagination__editor {
      height: 24px;
    }

    .el-input,
    .el-pagination__editor,
    .is-in-pagination {
      height: 24px;

      .el-input__inner {
        height: 24px;
      }
    }
  }

  .el-pagination,
  .is-background,
  .el-pagination--small {
    .el-pagination__sizes {
      height: 24px;
      line-height: 24px;
      margin: 0;
      position: relative;
      top: -1px;
    }
  }

  .el-pagination .el-select .el-input .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
}
</style>